import { z } from 'zod';
import errors from './errors';

export const phoneSchema = (lang: 'en' | 'de') =>
  z.string().regex(/^\d+$/, errors.phone[lang]);

export const otpSchema = z.coerce
  .number()
  .refine((value) => value >= 1000 && value <= 9999, {
    message: errors.otp,
  });

export const passwordSchema = z.string().refine(
  (value) => {
    return value.length >= 8;
  },
  {
    message: errors.password,
  }
);

export const confirmPasswordSchema = z.string().refine(
  (value) => {
    return value.length >= 8;
  },
  {
    message: errors.password,
  }
);

export const emailSchema = z.string().email({ message: errors.email['de'] });

/**
 * This is a duplicate of emailSchema as function, it uses lang for localize message.
 *
 * @param lang string
 * @returns z
 */
export const getEmailSchema = (lang: 'en' | 'de' = 'de') => {
  return z.string().email({ message: errors.email[lang] });
};

export const email = (message: string) => z.string().email({ message });
export const password = (message: string) => z.string();
export const confirmPassword = (message: string) =>
  z.string().min(8, { message });
export const phone = (message: string) => z.string().regex(/^\d+$/, message);
export const otp = (message: string) =>
  z.coerce.number().refine((value) => value >= 1000 && value <= 9999, {
    message,
  });
